/* OTS custom elements reconnect cleanly when Shopify's editor reloads sections. */
(() => {
  if (!customElements.get('ots-home-hero')) {
    customElements.define('ots-home-hero', class extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.measure = () => {
          const firstSection = document.querySelector('#MainContent > .shopify-section');
          const active = this.dataset.integrated === 'true' && firstSection?.contains(this) && this.header;
          this.dataset.active = String(Boolean(active));
          this.style.setProperty('--ots-offset', `${active ? this.header.offsetHeight : 0}px`);
        };
        this.measure();
        this.observer = new ResizeObserver(this.measure);
        if (this.header) this.observer.observe(this.header);
        this.reloadHeader = () => {
          this.observer.disconnect();
          this.header = document.querySelector('.section-header');
          if (this.header) { this.observer.observe(this.header); this.measure(); }
        };
        document.addEventListener('shopify:section:load', this.reloadHeader);
        document.addEventListener('shopify:section:reorder', this.measure);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('shopify:section:load', this.reloadHeader);
        document.removeEventListener('shopify:section:reorder', this.measure);
      }
    });
  }
  if (!customElements.get('ots-collections')) {
    customElements.define('ots-collections', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const grid = this.querySelector('.ots-collection-grid');
        const button = this.querySelector('.ots-more');
        if (!button || !grid) return;
        grid.dataset.collapsible = 'true';
        button.hidden = false;
        const expand = (expanded) => {
          grid.classList.toggle('ots-expanded', expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.less : button.dataset.more;
        };
        button.addEventListener('click', () => expand(button.getAttribute('aria-expanded') !== 'true'), { signal: this.events.signal });
        this.addEventListener('shopify:block:select', () => expand(true), { signal: this.events.signal });
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }
  if (!customElements.get('ots-featured-tunes')) {
    customElements.define('ots-featured-tunes', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const listen = (target, type, fn) => target.addEventListener(type, fn, { signal: this.events.signal });
        const status = this.querySelector('.ots-audio-status');
        this.players = [...this.querySelectorAll('audio')];
        for (const audio of this.players) {
          const card = audio.closest('.ots-tune');
          const button = card.querySelector('.ots-play');
          if (!button) continue;
          audio.hidden = true;
          button.hidden = false;
          const progress = card.querySelector('.ots-progress');
          const seek = progress.querySelector('input');
          const output = progress.querySelector('output');
          const time = (value) => Number.isFinite(value) ? `${Math.floor(value / 60)}:${String(Math.floor(value % 60)).padStart(2, '0')}` : '0:00';
          progress.hidden = false;
          const updateProgress = () => {
            seek.value = Number.isFinite(audio.duration) && audio.duration > 0 ? String(audio.currentTime / audio.duration * 1000) : '0';
            output.textContent = `${time(audio.currentTime)} / ${time(audio.duration)}`;
          };
          listen(audio, 'timeupdate', updateProgress);
          listen(audio, 'loadedmetadata', updateProgress);
          listen(seek, 'input', () => { if (Number.isFinite(audio.duration)) audio.currentTime = Number(seek.value) / 1000 * audio.duration; });
          let ticket = 0;
          const paint = (playing) => {
            card.classList.toggle('ots-playing', playing);
            button.setAttribute('aria-pressed', String(playing));
            const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
            button.querySelector('[data-play-label]').textContent = label;
            button.setAttribute('aria-label', `${label}: ${button.dataset.title}`);
          };
          listen(button, 'click', async () => {
            const request = ++ticket;
            if (!audio.paused) { audio.pause(); return; }
            document.querySelectorAll('ots-featured-tunes audio').forEach(other => { if (other !== audio) other.pause(); });
            card.classList.add('ots-has-played');
            button.setAttribute('aria-busy', 'true');
            try { await audio.play(); }
            catch { if (request === ticket) status.textContent = this.dataset.errorLabel; }
            finally { if (request === ticket) button.removeAttribute('aria-busy'); }
          });
          listen(audio, 'play', () => {
            document.querySelectorAll('ots-featured-tunes audio').forEach(other => { if (other !== audio) other.pause(); });
            paint(true);
            status.textContent = button.dataset.title;
          });
          listen(audio, 'pause', () => paint(false));
          listen(audio, 'ended', () => paint(false));
          listen(audio, 'error', () => { paint(false); status.textContent = this.dataset.errorLabel; });
        }
        listen(window, 'pagehide', () => this.players.forEach(audio => audio.pause()));
      }
      disconnectedCallback() { this.players?.forEach(audio => audio.pause()); this.events?.abort(); }
    });
  }
})();
